'use client';

import { useEffect } from 'react';
import ModuleList, {
  Module,
} from '@/components/utilities/content-modules/module-list/module-list';
import {
  trackPageLoadEvent,
  trackViewEvent,
} from '@/integrations/tracking/google-tag-manager/scripts';
import { tealiumView } from '@/integrations/tracking/tealium/scripts';
import CampaignPageHeader from './campaign-page-header/campaign-page-header';
import CampaignPageResults from './campaign-page-results/campaign-page-results';
import styles from './campaign.module.scss';

export interface CampaignProps {
  /** An array of the content modules to show */
  contentModules: Module[];
  /** An array of the header modules to show */
  headerModules: Module[];
  /** Personalization data for the user */
  personalizationData?: Content.Properties.PersonalizationData;
  /** Search settings for filters and search bar */
  searchSettings: Content.Components['SearchSettingsDto'];
  /** Tracking data for the page */
  trackingData?: Content.Properties.TrackingData;
}

const Campaign = ({
  contentModules,
  headerModules,
  personalizationData,
  searchSettings,
  trackingData,
}: CampaignProps) => {
  useEffect(() => {
    trackPageLoadEvent({ content_group: 'campaign' });

    personalizationData && tealiumView(personalizationData);

    if (!trackingData?.gtmDataLayer) return;

    trackViewEvent(trackingData.gtmDataLayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.component}>
      <ModuleList modules={headerModules} />

      <CampaignPageHeader searchSettings={searchSettings} />

      <CampaignPageResults searchSettings={searchSettings} />

      <ModuleList modules={contentModules} />
    </div>
  );
};

Campaign.displayName = 'Campaign';

export default Campaign;
